import { Record } from 'immutable';
import { take, fork, cancel, select } from 'redux-saga/effects';
import { LOCATION_CHANGE } from 'connected-react-router';
import constants from './constants';

const getTypeWithSuffix = suffix => action => action + suffix;

const requestType = getTypeWithSuffix(constants.REQUEST_SUFFIX);
const successType = getTypeWithSuffix(constants.SUCCESS_SUFFIX);
const failureType = getTypeWithSuffix(constants.FAILURE_SUFFIX);
const resetType = getTypeWithSuffix(constants.RESET_SUFFIX);
const eventType = getTypeWithSuffix(constants.EVENT_SUFFIX);

const requestReducerState = Record({
  [constants.DATA_KEY]: null,
  [constants.ERROR_KEY]: null,
  [constants.FETCHING_KEY]: false,
});

const requestReducer = type => (state = requestReducerState(), action) => {
  switch (action.type) {
    case requestType(type):
      return state
        .set(constants.ERROR_KEY, null)
        .set(constants.FETCHING_KEY, true);
    case successType(type):
      return state
        .set(constants.ERROR_KEY, null)
        .set(constants.FETCHING_KEY, false)
        .set(constants.DATA_KEY, action.payload);
    case failureType(type):
      return state
        .set(constants.FETCHING_KEY, false)
        .set(constants.ERROR_KEY, action.payload);
    case resetType(type):
      return requestReducerState();
    case eventType(type):
    default:
      return state;
  }
};

// Return true if the original and new locations are on the same desking page
// Specifically the finance offers tab is still on the desking page and should not stop polling
const deskingPageRegex = /\/pencil\/[0-9a-f-]+(\/?|\/finance-offers\/?)/;
function isStillOnDeskingPage(newLocation, originalLocation) {
  const isOriginalLocationDeskingPage = deskingPageRegex.test(
    originalLocation.pathname,
  );
  const isNewLocationDeskingPage = deskingPageRegex.test(newLocation.pathname);
  return isOriginalLocationDeskingPage && isNewLocationDeskingPage;
}

export function* pollingSaga(taskFn, resetActionType, action) {
  // Create polling task
  const task = yield fork(taskFn, action);

  // Wait for cancel condition
  while (true) {
    const currentState = yield select();
    const actionResult = yield take([LOCATION_CHANGE, resetActionType]);
    if (
      actionResult.type !== LOCATION_CHANGE ||
      !isStillOnDeskingPage(
        actionResult.payload.location,
        currentState.router.location,
      )
    ) {
      break;
    }
  }

  // Cancel the actual task
  yield cancel(task);
}

const util = {
  requestType,
  successType,
  failureType,
  resetType,
  eventType,
  requestReducer,
  requestReducerState,
  pollingSaga,
};

export default util;
